$(function () {
    var target = $('#localVideo');
    var source = target.data('video');
    var html = '';

    function append_video() {
        html +=
            '<video playsinline data-object-fit="cover">';
        html += '<source src="' + source + '" type="video/mp4">';
        html += '</video>';

        target.prepend(html);
    }

    function pause_play() {
        if (target.length) {
            var video = document.querySelector('.local-video video');
            var playPauseButton = document.querySelector('.playpause');
            var playPauseButtonText = document.querySelector('#local-video-controls-button-text');

            if (playPauseButton) {
                playPauseButton.classList.add('__play');

                // Play/Pause button
                playPauseButton.onclick = function () {
                    if (video.paused) {
                        // is paused, click to play
                        video.play();
                        playPauseButton.classList.remove('__play');
                        playPauseButton.classList.add('__pause');
                        playPauseButtonText.textContent = 'Pause';
                    } else {
                        // is playing, click to pause
                        video.pause();
                        playPauseButton.classList.add('__play');
                        playPauseButton.classList.remove('__pause');
                        playPauseButtonText.textContent = 'Play';
                    }
                };
            }
        }
    }

    function sound_mute() {
        if (target.length) {
            var video = document.querySelector('.local-video video');
            var soundMuteButton = document.querySelector('.soundmute');
            var soundMuteButtonText = document.querySelector('#local-video-controls-button-sound');

            function toggleMute() {
                video.muted = !video.muted;
            }

            if (soundMuteButton) {
                soundMuteButton.classList.add('__sound');

                // Play/Pause button
                soundMuteButton.onclick = function () {
                    toggleMute();
                    if (video.muted) {
                        // is muted, click to play sound
                        video.removeAttribute('muted');
                        soundMuteButton.classList.remove('__sound');
                        soundMuteButton.classList.add('__mute');
                        soundMuteButtonText.textContent = 'Mute';
                    } else {
                        // is playing, click to pause

                        video.setAttribute('muted', '');
                        soundMuteButton.classList.add('__sound');
                        soundMuteButton.classList.remove('__mute');
                        soundMuteButtonText.textContent = 'Sound';
                    }
                };
            }
        }
    }

    target.closest('.videoblock').find('.videoblock-overlay > button').on("click", function (e) {
        $(this).parent().css('display', 'none');
        target.attr('aria-hidden', 'false');
        target.attr('tabindex', '0');
        target.css('display', 'block');
        document.querySelector('.playpause').click();

    });

    append_video();
    pause_play();
    sound_mute();
});
